module.exports = __webpack_public_path__ + "static/media/signal-green@2x.13b516b6.png";